import { TERMS_MODULE_OPTINS } from "../../../../components/modules/compliance/config";
import { ONBOARDING_FULFILLED_BY_TYPES } from "../../../../components/shared/config";
import { flowBRDisabled } from "../../flowBRDisabled";
import { flowBREnabled } from "../../flowBREnabled";
import { flowClientSideKycSignature } from "../../flowClientSideKycSignature";
import { flowDisabledLoan } from "../../flowDisabledLoan";
import { flowWelcomeAndTerms } from "../../flowWelcomeAndTerms";
import { flowDefaultByMerchant } from "../../flowsByMerchant/flowDefaultByMerchant";
import { DISABLED_LOAN_STATUS } from "../constants/DisabledLoanStatus";

export const defaultFlows = [
  {
    ...flowDisabledLoan,
    condition: (processState, authState) => {
      return DISABLED_LOAN_STATUS.includes(processState?.loan?.status);
    },
  },
  {
    ...flowWelcomeAndTerms,
    condition: (processState, authState) => {
      return (
        !processState.participant.participantId ||
        !processState?.optIns ||
        (processState.participant.onboardingFulfilledBy !==
          ONBOARDING_FULFILLED_BY_TYPES.MERCHANT_POS &&
          processState?.optIns?.conditions_indicated
            .filter((condition) =>
              TERMS_MODULE_OPTINS.includes(condition.condition_type)
            )
            .some(
              (condition) => condition.required && condition.checked !== true
            ))
      );
    },
  },
  {
    ...flowClientSideKycSignature,
    condition: (processState, authState) => {
      return (
        processState?.participant?.onboardingDetails.fulfilled_by ===
        ONBOARDING_FULFILLED_BY_TYPES.CLIENT_SIDE_KYC_SIGNATURE
      );
    },
  },
  {
    ...flowDefaultByMerchant,
    condition: (processState, authState) => {
      return (
        processState?.participant?.onboardingFulfilledBy ===
        ONBOARDING_FULFILLED_BY_TYPES.MERCHANT_POS
      );
    },
  },
  {
    ...flowBREnabled,
    condition: (processState, authState) => {
      return authState?.agent?.is_bank_reader_enabled === true;
    },
  },
  {
    ...flowBRDisabled,
    condition: (processState, authState) => {
      return authState?.agent?.is_bank_reader_enabled === false;
    },
  },
];
